import { CardMedia, Grid, Typography } from "@mui/material";
import mission_imgUrl from "@/assets/images/about-us/building.jpg";
import Section from "@/components/Section";

const OurMission = () => {

  return (
    <Section pt={{ xs: 5, md: 6, lg: 12.5 }} pb={{ xs: 5, md: 6, lg: 12.5 }}>
      <Grid
        container
        columnSpacing={{ xs: 3, lg: 7.5 }}
        rowSpacing={{ xs: 4, lg: 0 }}
      >
        <Grid item xs={12} md={8}>
          <Typography variant="h2" mb={{ xs: 3, lg: 2 }} maxWidth={700}>
            Our mission
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color='text.secondary'
            maxWidth={700}
          >
            At Trackmate, our mission is clear and purposeful: to empower journeys and redefine excellence in GPS tracking. We are driven by a commitment to deliver intelligent, user-centric solutions that transcend conventional tracking experiences. Our mission encapsulates the essence of what we strive to achieve every day.
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <CardMedia
            component="img"
            image={mission_imgUrl}
            loading="lazy"
            alt="building"
            sx={{
              maxWidth: 516,
              height: "auto",
              margin: "0 auto",
            }}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default OurMission;
